import { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, FileText } from 'lucide-react';
import { FadeInUp } from '../components/animations';
import SEO from '../components/SEO';
import { breadcrumbSchema } from '../utils/schema';
import QuoteForm from '../components/contact/QuoteForm';
import GeneralInquiryForm from '../components/contact/GeneralInquiryForm';
import ContactInfoPanel from '../components/contact/ContactInfoPanel';

const ContactPage = () => {
  const [activeTab, setActiveTab] = useState('quote');

  return (
    <div className="pt-20" data-testid="contact-page">
      <SEO
        title="Contact Us | Taiga Sourcing"
        description="Get in touch with Taiga Sourcing. Request a quote, ask about sourcing from India, or contact our team for any enquiry."
        keywords="contact Taiga Sourcing, India sourcing contact, sourcing enquiry India"
        path="/contact"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])}
      />
      <section
        className="relative py-24 lg:py-32 bg-[#071E45] text-white"
        data-testid="contact-hero"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <FadeInUp>
            <p className="text-sm tracking-[0.3em] uppercase text-white/50 mb-4 font-medium">Get In Touch</p>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] mb-6"
              style={{ fontFamily: 'Cabinet Grotesk' }}
              data-testid="contact-title"
            >
              CONTACT US
            </h1>
            <p className="text-base text-white/70 leading-relaxed max-w-3xl mx-auto">
              Ready to start sourcing from India? Get in touch with our team.
            </p>
          </FadeInUp>
        </div>
      </section>

      <section className="py-32 bg-white" data-testid="contact-content">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <FadeInUp>
              <div>
                <div className="flex gap-4 mb-8 border-b border-[#0B2A57]/10">
                  <button
                    onClick={() => setActiveTab('quote')}
                    className={`pb-4 px-4 font-medium transition-all relative ${
                      activeTab === 'quote'
                        ? 'text-[#0B2A57]'
                        : 'text-[#6B7280] hover:text-[#0B2A57]'
                    }`}
                    data-testid="tab-quote"
                  >
                    <FileText size={20} className="inline mr-2" />
                    Request Quote
                    {activeTab === 'quote' && (
                      <motion.div
                        layoutId="activeTab"
                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#1E3D66]"
                      />
                    )}
                  </button>
                  <button
                    onClick={() => setActiveTab('contact')}
                    className={`pb-4 px-4 font-medium transition-all relative ${
                      activeTab === 'contact'
                        ? 'text-[#0B2A57]'
                        : 'text-[#6B7280] hover:text-[#0B2A57]'
                    }`}
                    data-testid="tab-contact"
                  >
                    <Mail size={20} className="inline mr-2" />
                    General Inquiry
                    {activeTab === 'contact' && (
                      <motion.div
                        layoutId="activeTab"
                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#1E3D66]"
                      />
                    )}
                  </button>
                </div>

                {activeTab === 'quote' ? <QuoteForm /> : <GeneralInquiryForm />}
              </div>
            </FadeInUp>

            <FadeInUp delay={0.2}>
              <ContactInfoPanel />
            </FadeInUp>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
